<!-- ============================================================================
     AI-JAVADOC: UfFormTypeObjectComponent Template
     Component: UfFormTypeObjectComponent
     Module: UF (Universal Forms)
     Description: Object detail view for UfFormType with three navigation tabs:
                  - Übersicht: CRUD form for the form type entity
                  - Felder: Table widget of UfFormTypeField entries
                  - Objektreferenzen: Table widget of UfFormTypeObjectReference entries
     ============================================================================ -->

@if (initialized && dto) {

    <!-- ==================== Tab: Übersicht ==================== -->
    @if (activeNavigationItems?.action == 'overview') {
        <div class="p-3">
            <mvs-crud-object-generic
                [objectType]="'uf.UfFormType'"
                [objectId]="objectIdentifier.objectId"
                (onChangedObject)="refreshObject(false)">
            </mvs-crud-object-generic>
        </div>
    }

    <!-- ==================== Tab: Felder ==================== -->
    @if (activeNavigationItems?.action == 'fields') {
        <div class="p-3">
            @if (fieldsWidget) {
                <mvs-widget [widgetData]="fieldsWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Objektreferenzen ==================== -->
    @if (activeNavigationItems?.action == 'objectReferences') {
        <div class="p-3">
            @if (objectReferencesWidget) {
                <mvs-widget [widgetData]="objectReferencesWidget"></mvs-widget>
            }
        </div>
    }

}
